import type { Position } from '@talos/kyoko';

export function getPositionKey(position: Position) {
  return position.rowID;
}

export function getPositionAsset(position: Position) {
  return position.Asset;
}
